import axios from "axios";
import store from '../store'
import { router } from '../main'

const api = axios.create({
  baseURL: "https://panterafood.com.br:21002",
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
			console.log("Deslogar");
      localStorage.removeItem("email" + localStorage.getItem("contrato"));
      localStorage.removeItem("nm" + localStorage.getItem("contrato"));
      localStorage.removeItem("cd" + localStorage.getItem("contrato"));
      store.commit("setLogado", false);

      router.push("/login");
    }
    return Promise.reject(error);
  }
);

export default api;
